<div class="infobar-comment" [attr.id]="'infobar-comment-'+widgetConfig.widgetId">
  <div style="width: 100%; height: 100%;">
    <textarea class="infobar-comment-textarea-field" [(ngModel)]="widgetConfig.comment" (ngModelChange)="changeComment()"></textarea>
  </div>
</div>
